import { Injectable, Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {SectorApi } from '../../../../theme/services/sdk';
import {BaToastNotificationService} from '../../../../theme/services/baToastNotification';


@Component({
  selector: 'app-sectors',
  templateUrl: './sectors.component.html',
  styleUrls: ['./sectors.component.scss'],
  providers:[SectorApi,BaToastNotificationService]
})

@Injectable()
export class SectorsComponent implements OnInit {

  private sectorSource = new BehaviorSubject<object>({})
  sector = this.sectorSource.asObservable();

  private sectorsSource = new BehaviorSubject<object>([])
  sectors = this.sectorsSource.asObservable();

  private totalItemsSource = new BehaviorSubject<number>(0)
  total_items = this.totalItemsSource.asObservable();

  private pSource = new BehaviorSubject<number>(1) // first page
  p = this.pSource.asObservable();

  private itemsPerPageSource = new BehaviorSubject<number>(10)
  itemsPerPage = this.itemsPerPageSource.asObservable();// number of items per page

  private searchingSource = new BehaviorSubject<boolean>(false)
  searching = this.searchingSource.asObservable();

  private editedIdSource = new BehaviorSubject<number>(null)
  editedId = this.editedIdSource.asObservable();

  constructor(protected sectorService:SectorApi,private toast: BaToastNotificationService) { }

  ngOnInit() {
    this.getSectors(this.pSource.getValue());
    this.getCount();
  }

  refresh(){
    this.pSource.next(1);
    this.getSectors(this.pSource.getValue());
    this.editedIdSource.next(null);
    this.getCount();
  }

  getSectors(page: number){
    let skip = ( page - 1) * this.itemsPerPageSource.getValue();
    this.sectorService.find({
      order: "id DESC",
      limit: this.itemsPerPageSource.getValue(),
      skip: skip
    })
        .subscribe((res) => {
              this.sectorsSource.next(res);
            },
            ((error) => {
              this.toast.error({
                heading: 'Error',
                text: 'Something went wrong. Reload to try again.',
                stack: 3
              });
            }))
  }

  getCount(){
    this.sectorService.count().subscribe((res) => {
      if(res)
        this.totalItemsSource.next(res.count);
    })
  }

  search(term: string, page:number){
    let skip = ( page - 1) * this.itemsPerPageSource.getValue();
    this.sectorService.search(term, this.itemsPerPageSource.getValue(), skip)
        .subscribe( results => {
              this.totalItemsSource.next(results.data.total);
              this.sectorsSource.next(results.data.sectors);
              this.searchingSource.next(false);
            },
            err => {
              this.toast.error({
                heading: 'Error',
                text: 'Something went wrong. Reload to try again.',
                stack: 3
              });
            })
  }

  updateSectorSource(data){
    this.sectorSource.next(data);
    this.editedIdSource.next(data.id);
  }

  cancelSelected(){
    this.editedIdSource.next(null);
    this.sectorSource.next({});
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/sectors/sectors.component.ts